export default class ClientConstants 
{
    public static  IDENTITY = "https://api.flyx2.cloud/identity";
    public static  CLIENT_PRIMARY_COLOR = "#00274F";
    public static  CLIENT_NAME = "Tamoil";
    public static  CLIENT_IMAGE = "https://www.tamoil.com/static/assets/logo.svg";
    public static ROUND_CLIENT_IMAGE = true;
}